let colorPalette = [
    /** 0 - undefined**/
    {stroke: "#2574ab", background: "#79b7e2", backgroundLight: "rgba(121,183,226,.2)"},

    /** 1 - Infections**/
    {stroke: "#4a0723", background: "#7f1642", backgroundLight: "rgba(189,146,231,.2)"},

    /** 2 - Stock Volume**/
    {stroke: "#727272", background: "#cdcdcd", backgroundLight: "rgba(132,214,224,.2)"},

    /** 3 - Open**/
    {stroke: "#35cbe2", background: "#a4e0f2", backgroundLight: "rgba(53,203,226,.2)"},

    /** 4 - High**/
    {stroke: "#457842", background: "#e7ffe6", backgroundLight: "rgba(231,255,230,.2)"},

    /** 5 - Low**/
    {stroke: "#c27575", background: "#ffeaea", backgroundLight: "rgba(255,234,234,.2)"},

    /** 6 - Red **/
    {stroke: "#dd0000", background: "#ffc7c7", backgroundLight: "rgba(255,199,199,.2)"},

    /** 7 - Green **/
    {stroke: "#009f04", background: "#d9ffda", backgroundLight: "rgba(217,255,218,.2)"},

    /** 8 **/
    {stroke: "#7F3E0B", background: "#c18e66", backgroundLight: "rgba(193,142,102,.2)"},

    /** 9 **/
    {stroke: "#486A7F", background: "#8ab8d5", backgroundLight: "rgba(138,184,213,.2)"},

    /** 10 **/
    {stroke: "#5bc0de", background: "#a4e0f2", backgroundLight: "rgba(164,224,242,.2)"},

    /** 11 **/
    {stroke: "#eeeb00", background: "#fffa8c", backgroundLight: "#fff9c4"},

    /** 12 **/
    {stroke: "#ed5847", background: "#ed877c", backgroundLight: "#edbdb7"},

    /** 13 **/
    {stroke: "#59a43d", background: "#59a43d", backgroundLight: "#c5edb3"},

    /** 14 **/
    {stroke: "#cccccc", background: "#e0e0e0", backgroundLight: "#f7f7f7"},

    /** 15 **/
    {stroke: "#666", background: "#666", backgroundLight: "#ccc"},

    /** 16 **/
    {stroke: "#811282", background: "#fd65ff", backgroundLight: "#ffe7ff"},

    /** 17 **/
    {stroke: "#eabb00", background: "#f3e4aa", backgroundLight: "#f3e4aa"}
];

export default class Config {
  static get colorPalette() { return colorPalette; }
}



// WEBPACK FOOTER //
// ./src/Config.js